import { Table } from './Table';
import { Select } from './Select';
import React, { useEffect, useState } from 'react';
import { OrderPaidProduct, ProductSize, TOrderDetail } from '../types/types';
import { getProductSizes } from '../apis/products';
import { sortedSizeObjects } from '../utils/sortedSizes';
import { swapProductShippingStatus } from '../utils/texts';

type EditSizeItemProps = {
  order: TOrderDetail;
  product: OrderPaidProduct;
  isMobile?: boolean;
  onSelectSize: (orderProductId: number, id: number) => void;
};

const ProductEditSizeItem = (props: EditSizeItemProps) => {
  const { order, product, isMobile, onSelectSize } = props;
  const [sizes, setSizes] = useState<ProductSize[]>([]);

  const productShippingStatus = order.status === 'CANCELED' ? '주문취소' : order.status === 'WAIT' ? '결제대기' : swapProductShippingStatus(product.productStatus, product.latestRequest, product.latestRequestStatus!)

  useEffect(() => {
    getProductSizes(product.productId).then(r =>
      setSizes(sortedSizeObjects(r.data.payload, 'sizeName')),
    );
  }, []);

  const currentSizesStocks = (list: ProductSize[]) => {
    const stocksList = list.filter(item => item.currentStock > 0);
    if (stocksList.length === 0) {
      return '없음';
    } else {
      return sortedSizeObjects(stocksList, 'sizeName')
        .map(item => item.sizeName)
        .join(', ');
    }
  };

  if (isMobile) {
    return (
      <div className="flex space-x-2 border-b pb-4 pt-2">
        <div className="w-20 h-28 rounded-md overflow-hidden relative">
          <img
            src={product.thumbnailUrl}
            alt=""
            className="w-full h-full object-cover absolute"
          />
        </div>

        <div className="flex-1 text-10 text-brand-3 font-bold pr-4">
          <p className="text-brand-1">{product.productName}</p>
          <p className="">{product.color}</p>
          <p className="py-2">
            {product.unitPrice.toLocaleString()}원 /수량 {product.count}개
          </p>
          <p className="">
            적립금 적립 : {product.earnedMileage.toLocaleString()}원
          </p>
          <p className="">
            총 결제금액 : {product.totalPrice.toLocaleString()}원
          </p>
        </div>

        <div className="space-y-3 w-1/5">
          <p className='text-13 font-bold'>{productShippingStatus}</p>
          <Select
            className="border border-gray-100 pl-4"
            defaultValue={product.sizeId}
            onChange={e =>
              onSelectSize(product.orderProductId, parseInt(e.target.value))
            }>
            <option hidden={true} value={product.sizeName}>
              {product.sizeName}
            </option>
            {sizes.map((item, index) => {
              if (item.currentStock > 0)
                return (
                  <option
                    key={index}
                    hidden={product.sizeName === item.sizeName}
                    value={item.productSizeId}>
                    {item.sizeName}
                  </option>
                );
            })}
          </Select>
          <p className="text-10 text-red-500 font-normal">
            남은 사이즈 : {currentSizesStocks(sizes)}
          </p>
        </div>
      </div>
    );
  } else {
    return (
      <Table.Row>
        {/*<Table.Td>*/}
        {/*    <Checkbox className="bg-white border border-gray-300"/>*/}
        {/*</Table.Td>*/}

        <Table.Td>
          <div className="flex space-x-4 font-normal items-center">
            <div className="w-20 h-28 relative rounded-md overflow-hidden">
              <img
                src={product.thumbnailUrl}
                alt=""
                className="w-full h-full object-cover absolute"
              />
            </div>
            <div className="space-y-2 text-10 font-semibold">
              <p className="whitespace-normal">
                {product.productName}
                <br />
                <span className="text-brand-3">{product.color}</span>
              </p>
              <p className="text-brand-3">
                {product.unitPrice.toLocaleString()}원/수량{product.count}개
              </p>
            </div>
          </div>
        </Table.Td>
        <Table.Td>
          <div className="space-y-3">
            <Select
              className="border border-gray-100 pl-4"
              defaultValue={product.sizeId}
              onChange={e =>
                onSelectSize(product.orderProductId, parseInt(e.target.value))
              }>
              <option hidden={true} value={product.sizeName}>
                {product.sizeName}
              </option>
              {sizes.map((item, index) => {
                if (item.currentStock > 0)
                  return (
                    <option
                      key={index}
                      hidden={product.sizeName === item.sizeName}
                      value={item.productSizeId}>
                      {item.sizeName}
                    </option>
                  );
              })}
            </Select>
            <p className="text-13 text-red-500 font-normal">
              남은 사이즈 : {currentSizesStocks(sizes)}
            </p>
          </div>
        </Table.Td>
        <Table.Td>{product.earnedMileage.toLocaleString()}원</Table.Td>
        <Table.Td>{product.totalPrice.toLocaleString()}원</Table.Td>
      </Table.Row>
    );
  }
};

export default ProductEditSizeItem;
